// extracted by mini-css-extract-plugin
module.exports = {"link":"LoadMoreBtn-module__link"};